module.exports = __webpack_public_path__ + "00_mole.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/00_mole.png
// module id = 60i9
// module chunks = 0